<script>
    import '@material/mwc-icon';
    import '@material/mwc-icon-button';
    import '@material/mwc-list/mwc-list-item';
    import '@material/mwc-linear-progress';
    import '@material/mwc-menu';
    import jwtdecode from "jwt-decode";
    import { get_current_component } from 'svelte/internal';
    
    const currentComponent = get_current_component();

    let token;
    let apiKey;
    let user;
    let projects;

    let stateIcons = {
        0: "history_toggle_off",
        1: "history_toggle_off",
        2: "launch",
        3: "history_toggle_off",
        4: "highlight_off",
        5: "highlight_off",
        6: "highlight_off"
    }

    function url(path) {
        return "https://hq.spicaengine.com/api" + path;
    }

    function onIframeReady(event) {
        const iframe = event.path[0];
        window.addEventListener("message", ({origin,data}) => {
            if ( origin !=  window.origin ) {
                const {key, authorization} = data;
                token = authorization;
                apiKey = key;
                if ( token ) {
                    user = jwtdecode(token);
                    user._id = jwtdecode(token, {header: true})._id;
                }

                fetchServers();
            }
        });
        iframe.contentWindow.postMessage("exchange", url(""));
    }
    function fetchServers() {
        if ( token ) {
            projects = fetch(url('fn-execute/getMyProjects?type=mine'), {headers: {Authorization: 'IDENTITY ' + token}}).then((r) => r.json());
        } else {
            projects = undefined;
        }
    }
    function openMenu(e) {
        const menu = currentComponent.shadowRoot.querySelector("mwc-menu");
        menu.open = !menu.open;
        e.stopPropagation();
    }
    function closeMenu() {
        const menu = currentComponent.shadowRoot.querySelector("mwc-menu");
        if ( menu ) {
            menu.open = false
        }
    }
    function gotoProject(server) {
        fetch(`//${server.ip_address}/api/passport/strategies`).then(r => r.json()).then(strategies => {
            const hqStrategy = strategies.find(s => s.name == "headquarters");
            window.open(`//${server.ip_address}/passport/identify?strategy=${hqStrategy._id}`)
        })
    }
</script>

<style>
   div {
        position: relative;
   }
   iframe {
       display:none;
   }
   mwc-list-item:first-of-type span {
        padding-right: 15px;
   }
   mwc-list-item.project {
       color:#444;
       font-size: 14px;
   }
   mwc-list-item.project span {
       padding-right: 15px;
   }
   mwc-list-item.project mwc-icon {
        font-size: 14px;
   }
   mwc-list-item:last-of-type {
       color:#444;
       justify-content: center;
   }
   mwc-list-item.no-project{
        --mdc-ripple-color: transparent;
        color: #000;
        font-size: 18px;
   }
</style>

<iframe title="Spica HeadQuarters FIM" src={url("/fn-execute/v1/state")} on:load={onIframeReady}></iframe>

{#if token != null}
<div>
    <mwc-icon-button raised icon="next_plan" on:click={openMenu}></mwc-icon-button>
    <mwc-menu anchor={currentComponent} fixed corner="BOTTOM_START">
        <mwc-list-item noninteractive={true} hasMeta>
            <span>Hi, {user.name}</span>
            <mwc-icon slot="meta">insert_emoticon</mwc-icon>
        </mwc-list-item>
        <li divider padded role="separator"></li>
        {#await projects}
          <mwc-linear-progress indeterminate="true"></mwc-linear-progress>
        {:then projects}
            {#if !projects.length}
                <mwc-list-item class="no-project">
                    You have no project
                </mwc-list-item>
                <li divider padded role="separator"></li>
            {/if}
            {#each projects as project}
                <mwc-list-item class="project" hasMeta on:click={gotoProject(project.server)} noninteractive={project.server.state != 2}>
                    <span>{project.server.version || 'latest'}</span>
                    <span>{project.server.name}</span>
                    <mwc-icon slot="meta">{stateIcons[project.server.state] || 'help_outline'}</mwc-icon>
                </mwc-list-item>
                <li divider padded role="separator"></li>
            {/each}
        {:catch error} 
            {error.message}
        {/await}
        <mwc-list-item noninteractive={true}>
            <small>Spica Headquarters</small>
        </mwc-list-item>
    </mwc-menu>
</div>
{:else}
    <!--<mwc-icon-button raised icon="login" on:click={() => location.href = "https://dashboard.spicaengine.com/login?callback="+location.href}></mwc-icon-button>-->
{/if}

<svelte:window on:click={closeMenu} />
<svelte:options tag="toolbar-action" immutable={true} />